import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from '../AdminSidebar';
import AdminHeader from '../AdminHeader';
import { useSidebar } from '../../../contexts/SidebarContext';
import { DashboardThemeProvider } from '../../../contexts/DashboardThemeContext';

const AdminLayout = () => {
  const { isAdminSidebarCollapsed, isAdminMobileSidebarOpen } = useSidebar();

  return (
    <DashboardThemeProvider variant="admin">
      <div className="dashboard-app min-h-screen bg-gray-50 dark:bg-gray-950 transition-colors">
        <AdminHeader />
        <div className="flex pt-20">
          <AdminSidebar />
          <main
            className={`dashboard-main flex-1 transition-all duration-300 ${
              isAdminSidebarCollapsed ? 'lg:ml-16' : 'lg:ml-64'
            } ${isAdminMobileSidebarOpen ? 'lg:ml-0' : ''}`}
          >
            <div className="p-4 sm:p-6">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </DashboardThemeProvider>
  );
};

export default AdminLayout;
